import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let filters = useDataValue({
    context: 'user_preferences',
    path: 'timeline_filter_presets',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    return filters.filter(item => item.value).map(item => item.id)
  }, [data, filters])
}
